import { useCallback, useState } from "react";
import { Apis } from "../../../lib/Apis";

const getErrorMessage = (error, fallback) =>
  error?.response?.data?.message || error?.message || fallback;

export function useStaticPages() {
  const [loading, setLoading] = useState(false);

  const getList = useCallback(async (params) => {
    setLoading(true);
    try {
      const response = await Apis.getStaticPages(params);
      return response?.data?.data || { items: [], pagination: {} };
    } finally {
      setLoading(false);
    }
  }, []);

  const getAvailableUrls = useCallback(async () => {
    const response = await Apis.getStaticPageAvailableUrls();
    return response?.data?.data?.urls || [];
  }, []);

  const createStaticPage = useCallback(async (payload) => {
    try {
      const response = await Apis.createStaticPage(payload);
      if (response?.data?.success || response?.status === 201) {
        return response.data;
      }
      throw new Error(
        response?.data?.message || "Failed to create static page SEO",
      );
    } catch (error) {
      throw new Error(
        getErrorMessage(error, "Failed to create static page SEO"),
      );
    }
  }, []);

  const updateStaticPage = useCallback(async (id, payload) => {
    try {
      const response = await Apis.updateStaticPage(id, payload);
      if (response?.data?.success || response?.status === 200) {
        return response.data;
      }
      throw new Error(
        response?.data?.message || "Failed to update static page SEO",
      );
    } catch (error) {
      throw new Error(
        getErrorMessage(error, "Failed to update static page SEO"),
      );
    }
  }, []);

  return {
    loading,
    getList,
    getAvailableUrls,
    createStaticPage,
    updateStaticPage,
  };
}
